module.exports = __webpack_public_path__ + "img/crab.64a9c2fc.jpg";